import BaseField from "../../ui/BaseField";
import ValueWithFallback from "../../ui/ValueWithFallback";
import FormatPhoneNumber from "../../utils/FormatPhoneNumber";

const PhoneNumber = ({ fieldName, number, flag, clock }) => {
  return (
    <BaseField
      id="SB-Phone"
      testId="SB-Phone"
      fieldName={fieldName}
      label={null}
      flag={flag}
      clock={clock}
    >
      {ValueWithFallback(FormatPhoneNumber(number))}{" "}
    </BaseField>
  );
};

export default PhoneNumber;
